import { render } from "./CreateCampaign.vue?vue&type=template&id=daf8d13e&scoped=true"
import script from "./CreateCampaign.vue?vue&type=script&lang=js"
export * from "./CreateCampaign.vue?vue&type=script&lang=js"

import "./CreateCampaign.vue?vue&type=style&index=0&id=daf8d13e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf8d13e"]])

export default __exports__